module.exports = __webpack_public_path__ + "media/images/flags/16/Anguilla-250d43247b154856310c087dc747c1b6.png";